import { render, staticRenderFns } from "./new_proxy.vue?vue&type=template&id=212b42e7"
import script from "./new_proxy.vue?vue&type=script&lang=ts"
export * from "./new_proxy.vue?vue&type=script&lang=ts"
import style0 from "./new_proxy.vue?vue&type=style&index=0&id=212b42e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports